import { render, staticRenderFns } from "./taxModal.vue?vue&type=template&id=3fc30a8c&scoped=true&"
import script from "./taxModal.vue?vue&type=script&lang=js&"
export * from "./taxModal.vue?vue&type=script&lang=js&"
import style0 from "./taxModal.vue?vue&type=style&index=0&id=3fc30a8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc30a8c",
  null
  
)

export default component.exports